import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { auth } from '../firebase/config';
import SocialLoginButton from '../components/SocialLoginButtons';

const HomePage: React.FC = () => {
  const { t } = useTranslation();
  const { isAuthenticated, user, loginWithGoogle } = useAuth();

  const handleGoogleLogin = async () => {
    console.log('🔘 Google login button clicked! (HomePage)');
    console.log('🔍 Testing basic functionality...');
    
    try {
      console.log('🔄 Starting Google login process...');
      
      // 기본 테스트: Firebase Auth 객체 확인
      console.log('🔍 Firebase Auth object:', auth);
      console.log('🔍 Current user:', auth.currentUser);
      
      await loginWithGoogle();
    } catch (e: any) {
      const c = e?.code || '';
      console.log('❌ Google login error caught:', c);
      console.log('❌ Full error:', e);
      
      // 폴백 대상 에러는 무시 (이미 signInWithRedirect 실행됨)
      if (
        c === 'auth/popup-blocked' ||
        c === 'auth/popup-closed-by-user' ||
        c === 'auth/cancelled-popup-request' ||
        c === 'auth/web-storage-unsupported'
      ) {
        console.log('🔄 Ignoring fallback error');
        return;
      }
      console.error('Google 로그인 실패:', e);
      // 사용자에게 에러 메시지 표시
      alert(`Google 로그인 실패: ${e.message || '알 수 없는 오류'}`);
    }
  };

  console.log('🏠 HomePage rendering, isAuthenticated:', isAuthenticated);

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f0f8ff', 
      padding: '20px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ 
        maxWidth: '800px', 
        margin: '0 auto', 
        textAlign: 'center',
        padding: '40px 20px'
      }}>
        <h1 style={{ 
          fontSize: '48px', 
          fontWeight: 'bold', 
          color: '#333',
          marginBottom: '20px'
        }}>
          ScanVCF Web
        </h1>
        
        <p style={{ 
          fontSize: '20px', 
          color: '#666',
          marginBottom: '40px'
        }}>
          디지털 명함을 웹에서도 관리하세요
        </p>
        
        {isAuthenticated ? (
          <div>
            <p style={{ fontSize: '18px', color: '#333', marginBottom: '20px' }}>
              안녕하세요, {user?.displayName || user?.email}님!
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <Link
                to="/dashboard"
                style={{
                  backgroundColor: '#2563eb',
                  color: 'white',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: 'bold'
                }}
              >
                대시보드로 이동
              </Link>
            </div>
          </div>
        ) : (
          <div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '20px' }}>
              <Link
                to="/login"
                style={{
                  backgroundColor: '#2563eb',
                  color: 'white',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: 'bold'
                }}
              >
                로그인
              </Link>
              <Link
                to="/register"
                style={{
                  backgroundColor: '#059669',
                  color: 'white',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: 'bold'
                }}
              >
                회원가입
              </Link>
            </div>
            
            <SocialLoginButton
              provider="google"
              onClick={handleGoogleLogin}
              size="md"
              variant="button"
              className="mx-auto"
            />

            {/* 테스트 버튼 추가 */}
            <button
              onClick={() => {
                console.log('🧪 Test button clicked!');
                alert('테스트 버튼이 클릭되었습니다!');
              }}
              style={{
                backgroundColor: 'red',
                color: 'white',
                padding: '8px 16px',
                borderRadius: '4px',
                border: 'none',
                marginTop: '10px',
                cursor: 'pointer'
              }}
            >
              테스트 버튼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomePage; 